export default "__VITE_ASSET__Byw_eyfp__"